import React from "react";
import {
  Box,
  Flex,
  Image,
  Text,
} from "@chakra-ui/react";
import TableSaleContractStatement from "./tableSaleContractStatement";
import backIcon from "../../assets/images/arrow-left2.svg";
import { useNavigate } from "react-router-dom";

export default function SaleContractStatement() {
  const navigate = useNavigate();

  const statement = () => {
    navigate("/statement");
  };
  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex
          alignItems={"center"}
          gap={{ base: "4px" }}
          cursor={"pointer"}
          mb={"16px"}
          onClick={statement}
        >
          <Image w={"22px"} src={backIcon} />
          <Text fontSize={{ base: "16px" }} fontWeight={600}>
            Quay lại
          </Text>
        </Flex>
      </Flex>
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Thống kê HĐMB đã duyệt
          </Text>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableSaleContractStatement />
      </Box>
    </Box>
  );
}
